export default function RedirectToDiscord() {
  window.location.replace("https://discord.com/invite/8NcVkyduG3");
  return null;
}